module.exports = __webpack_public_path__ + "img/lang-4.4d8c14ce.jpg";